import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { Trans } from 'react-i18next';

import Page, { PageMenu } from 'src/components/Page';
import Box from 'src/components/Box';
import logger from 'src/utils/logger';
import AccessDeniedCustomPage from 'src/pages/AccessDeniedCustomPage';
import AccessDeniedPage from 'src/pages/AccessDeniedPage';
import * as Sentry from '@sentry/browser';
import getEnv from 'src/utils/api/env';
import Button from 'src/components/Button';
import Styled from './ErrorBoundary.styles';

class ErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.string,
      PropTypes.node,
    ]).isRequired,
  };
  
  state = { error: null, errorInfo: null };

  static getDerivedStateFromError(error) {
    logger.info(error);
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });

    const sentryAvailableEnvironments = ['STAGING', 'DEV', 'PROD', 'ONBOARD'];
    if (sentryAvailableEnvironments.includes(getEnv())) {
        Sentry.captureException(error);
    }
  }

  render() {
    const { children } = this.props;
    const { errorInfo, error } = this.state;

    const urlParameter = queryString.parse(window.location.search);
    const requestingUrl = urlParameter.requesting_url;

    if (!errorInfo) return children;

    if (error.message === 'Unauthorized request' && requestingUrl) {
      return (
        <Styled.Wrapper>
          <AccessDeniedCustomPage requestingUrl={requestingUrl} />
        </Styled.Wrapper>
      );
    }

    if (error.message === 'Unauthorized request') {
      return (
        <Styled.Wrapper>
          <AccessDeniedPage />
        </Styled.Wrapper>
      );
    }

    const env = getEnv();
    const environmentsToShowStackTrace = ['LOCAL', 'STAGING', 'DEV', 'ONBOARD'];

    return (
      <Page>
        <PageMenu />
        <Box>
          <Styled.Wrapper>
            <Styled.Title>
              <Trans>ERROR_OCCURED</Trans>
            </Styled.Title>
            {environmentsToShowStackTrace.includes(env) && (
              <Styled.Stack>
                {error && error.toString()}
                {errorInfo.componentStack}
              </Styled.Stack>
            )}

            <Button sm solid type="button" onClick={() => window.location.reload()}>
              <Trans>RELOAD_PAGE</Trans>
            </Button>
          </Styled.Wrapper>
        </Box>
      </Page>
    );
  }
}

export default ErrorBoundary;
